import { render, staticRenderFns } from "./ListWrap.vue?vue&type=template&id=6b6220ea&scoped=true"
import script from "./ListWrap.vue?vue&type=script&lang=js"
export * from "./ListWrap.vue?vue&type=script&lang=js"
import style0 from "./ListWrap.vue?vue&type=style&index=0&id=6b6220ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6220ea",
  null
  
)

export default component.exports